"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegalFS = void 0;
var legalFSshort_cms_1 = require("./legalFSshort.cms");
var LegalFS = /** @class */ (function () {
    function LegalFS() {
        this.legalModalPath = [
            '/idpassets/fragment/legal/prod/legalmodal/offers/wireline/checkout/freeshippinglm.cmsfeed.js',
        ];
        this.legalShortPath = new legalFSshort_cms_1.LegalFSShort();
    }
    return LegalFS;
}());
exports.LegalFS = LegalFS;
//# sourceMappingURL=legalFS.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/DeliveryInfoWLS/legalFS.cms.js
// module id = 1991
// module chunks = 8